export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;
export const CELL_SIZE = 30;
export const TICK_RATE = 60;

export const DAS_DELAY = 10;  // frames before auto-repeat starts
export const DAS_RATE = 2;    // frames between auto-repeats

export const LOCK_DELAY = 30; // frames before piece locks after landing

export const COLORS: Record<number, string> = {
  0: '#0a0a0a',  // empty
  1: '#00f0f0',  // I - cyan
  2: '#f0f000',  // O - yellow
  3: '#a000f0',  // T - purple
  4: '#00f000',  // S - green
  5: '#f00000',  // Z - red
  6: '#0000f0',  // J - blue
  7: '#f0a000',  // L - orange
  8: '#808080',  // garbage - gray
};

export const GHOST_ALPHA = 0.3;

// Gravity per level (frames per cell drop)
export const GRAVITY: number[] = [
  48, 43, 38, 33, 28, 23, 18, 13, 8, 6,
  5, 5, 5, 4, 4, 4, 3, 3, 3, 2,
  2, 2, 2, 2, 2, 2, 2, 2, 2, 1,
];

export const LINES_PER_LEVEL = 10;
